import React from 'react';

import { flagStyles } from '../settings';

const SvgDK = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1368px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgDK;
